import { useEffect, useRef, useState } from 'react';

const DEFAULT_DT = [];
const DEFAULT_PARAMS = {
  page: {
    skip: 0,
    take: 10,
  },
  pageSize: 10,
};

export const useClientSidePagination = (active = false, data = DEFAULT_DT, params = DEFAULT_PARAMS) => {
  const [page, setPage] = useState({
    skip: params?.page?.skip || DEFAULT_PARAMS.page.skip,
    take: params?.page?.take || DEFAULT_PARAMS.page.take,
  });

  const initialParams = useRef(page);

  const [pageSize, setPageSize] = useState(params?.pageSize || DEFAULT_PARAMS.pageSize);

  const getPageData = (pg) => data?.slice(pg?.skip, pg?.take + pg?.skip);

  const [pageData, setPageData] = useState();

  const onPageChanged = (event) => {
    const targetEvent = event?.targetEvent;
    const take = targetEvent?.value === 'All' ? params.total : event.page.take;

    const newPage = {
      ...event.page,
      take,
    };

    if (targetEvent.value) {
      newPage.take = targetEvent.value;
      setPageSize(targetEvent.value);
    }

    setPage(newPage);
    setPageData(getPageData(newPage));
  };

  useEffect(() => {
    if (active) {
      const newPage = {
        ...initialParams?.current,
        take: pageSize,
      };
      setPage(newPage);
      setPageData(getPageData(newPage));
    }
  }, [active, data]);

  return {
    page,
    pageData,
    pageSize,
    total: data.length,
    onPageChanged,
  };
};